import { useAppSelector } from 'store'
import $customer, { CustomerBookingField } from 'store/customer'

import App from 'components/App'
import { useTranslation } from 'react-i18next'

type FieldValues = {
  [key: string]: any
}

type Props = {
  values: FieldValues
  errors: Record<string, string>
  onFieldChange: (fieldName: string, value: any) => void
  unfilledFields?: CustomerBookingField[]
}

const HelperBookingFields: React.FC<Props> = ({ values, errors, onFieldChange, unfilledFields: unfilledFieldsProp }) => {
  const { t } = useTranslation()
  
  const unfilledFieldsFromStore = useAppSelector($customer.get.unfilledFields)
  const unfilledFields = unfilledFieldsProp ?? unfilledFieldsFromStore

  const renderField = (field: CustomerBookingField) => {
    const value = values[field.name] ?? (field.type === 'multilist' ? [] : '')
    const error = errors[field.name] || ''

    switch (field.type) {
      case 'text':
      case 'email':
        return (
          <App.Input
            type={field.type}
            value={value}
            placeholder={t(field.translationKey)}
            error={error}
            onChange={(val) => onFieldChange(field.name, val)}
          />
        )

      case 'date':
        return (
          <App.Datepicker
            type="date"
            value={String(value)}
            placeholder={t(field.translationKey)}
            error={error}
            onChange={(val) => onFieldChange(field.name, val)}
          />
        )

      case 'datetime':
        return (
          <App.Datepicker
            type="datetime"
            value={String(value)}
            placeholder={t(field.translationKey)}
            error={error}
            onChange={(val) => onFieldChange(field.name, val)}
          />
        )

      case 'list':
      case 'multilist':
        const options = field.values?.map(v => ({
          value: v.id,
          label: v.value
        })) || []

        const genderOptions = field.name === 'gender' && !field.values?.length ? [
          { value: '0', label: t('Male') },
          { value: '1', label: t('Female') }
        ] : options

        return (
          <App.Dropdown
            value={value}
            options={field.name === 'gender' && !field.values?.length ? genderOptions : options}
            placeholder={t(field.translationKey)}
            multiple={field.type === 'multilist'}
            error={error}
            onChange={(val) => onFieldChange(field.name, val)}
          />
        )

      default:
        return (
          <App.Input
            value={value}
            placeholder={t(field.translationKey)}
            error={error}
            onChange={(val) => onFieldChange(field.name, val)}
          />
        )
    }
  }

  return unfilledFields.length ? (
    <App.Flex column gap={4}>
      {unfilledFields.map((field: CustomerBookingField) => (
        <App.Flex key={field.name} column gap={1}>
          {/* <App.Text small>{t(field.translationKey)}{field.required && <App.Text danger> *</App.Text>}</App.Text> */}

          {renderField(field)}
        </App.Flex>
      ))}
    </App.Flex>
  ) : null
}

export default HelperBookingFields